import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';
import {PlusMinusButtonComponent} from './plus-minus-button.component';
import {CircleButtonComponent} from './circle-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent, PlusMinusButtonComponent, CircleButtonComponent],
  selector: 'app-plus-minus-micro-button',
  template: `
    <div class="items-center flex flex-row gap-2 relative">
      <app-base-button
        [baseClass]="'rounded-full w-10 h-6 flex justify-center items-center border border-theme-primary border-[0.1rem]' + dynamicClasses()"
        (onClick)="toggleVis()"
        [disabled]="disabled"
        [blocked]="blocked"
      >
        <div class="text-theme-primary text-base font-bold min-w-8 text-center border-theme-primary">{{(amount!=null && amount!==0)?amount+' x':"+"}}</div>
      </app-base-button>
      <div class="absolute -top-28 z-20" *ngIf="vis">
        <div class="bg-theme-surface2 py-2 px-4 rounded-lg flex flex-col shadow-lg border border-theme-surface2-dim">
          <div class="py-1">Valt {{totalCount}} av {{maxCount}} {{unit}}</div>
          <div class="flex gap-4 items-center">
            <div class="bg-theme-surface rounded-lg">
              <app-plus-minus-button [count]="amount!" (countChange)="changeAbsolute($event);" [allowRemove]="true" [remaining]="remaining"></app-plus-minus-button>
            </div>
            <app-circle-button size="12" (onClick)="toggleVis()" type="solid-light" icon="fa-close" fontSize="xl"></app-circle-button>
          </div>
        </div>
      </div>
    </div>
  `
})
export class PlusMinusMicroButtonComponent {
  @Input() disabled: boolean = false;
  @Input() blocked: boolean = false;
  @Input() amount: number|undefined = undefined;
  @Input() remaining: number|undefined = undefined;
  @Input() totalCount: number = 0;
  @Input() maxCount: number = 0;
  @Input() unit: string = '';
  @Output() onChangeAmount = new EventEmitter<number>();
  @Output() onChangeVis = new EventEmitter<boolean>();
  @Input() vis!: boolean;

  dynamicClasses(){
    if (this.disabled) {
      return ' opacity-50 ';
    }
    if (this.vis) {
      return ' bg-theme-surface-50 ';
    } else {
      return '';
    }
  }

  change(number: number) {
    this.onChangeAmount.emit(number);
  }

  toggleVis() {
    console.log('toggleVis');
    this.onChangeVis.emit(!this.vis);
  }

  changeAbsolute($event: number) {
    console.log($event);
    if ($event > this.amount!) {
      this.change(1);
    } else {
      this.change(-1);
    }
  }
}
